import React from 'react';
import Clock from 'react-live-clock';
import { Typography, Stack } from '@mui/material';

export default function LocalDateTime() {
  return (
    <Stack direction="row" spacing={1} sx={{ color: '#637381' }}>
      <Typography variant="caption"><b>Local:</b></Typography>
      <Typography variant="caption">
        <Clock format={'YYYY-MM-DD HH:mm:ss'} ticking />
      </Typography>
    </Stack>
  );
}
